import { __assign } from 'tslib';
import React from 'react';
import { Title } from '../title/component.js';
import { c as commonStyles } from '../common.module-a0a4a875.js';
import 'react-merge-refs';
import 'classnames';
import '../hooks/useSkeleton.js';
import '@alfalab/core-components-skeleton/esm';
import '@alfalab/hooks';
import '../colors.module-64858915.js';

var styles = {"styrene-xlarge":"typography__styrene-xlarge_kymfk","styrene-large":"typography__styrene-large_kymfk","styrene-medium":"typography__styrene-medium_kymfk","styrene-small":"typography__styrene-small_kymfk","styrene-xsmall":"typography__styrene-xsmall_kymfk","system-xlarge":"typography__system-xlarge_kymfk","system-large":"typography__system-large_kymfk","system-medium":"typography__system-medium_kymfk","system-small":"typography__system-small_kymfk","system-xsmall":"typography__system-xsmall_kymfk"};
require('./index.css')

var TitleMobile = function (props) { return (
/**
 * Если поменять Object.assign на деструктуризацию, то упадут тесты.
 * Видимо, это особенность работы jest и css-modules.
 */
React.createElement(Title, __assign({}, props, { styles: Object.assign(commonStyles, styles) }))); };

export { TitleMobile };
